import { render, staticRenderFns } from "./PagosMultas.vue?vue&type=template&id=147d9e21&"
import script from "./PagosMultas.vue?vue&type=script&lang=js&"
export * from "./PagosMultas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports